<swiper [speed]="speed" [direction]="direction" [autoHeight]="autoHeight" [roundLengths]="roundLengths"
    [slidesPerView]="slidesPerView" [centeredSlides]="centeredSlides" [spaceBetween]="spaceBetween"
    [slideToClickedSlide]="slideToClickedSlide" [loop]="loop" [breakpoints]="breakpoints" [navigation]="navigation"
    [pagination]="pagination" [autoplay]="autoPlay">
    <ng-template swiperSlide *ngFor="let slide of sliders">
        <div class="position-relative">
            <a [href]="slide.link" [attr.aria-label]="slide.ariaLabel" class="d-block js-btn-data-layer"
                rel="noreferrer" target="_blank" rel="noopener">
                <picture>
                    <source *ngFor="let objSrc of slide.sources" [media]="'(min-width: '+objSrc.minWidth+'px)'"
                        [type]="objSrc.typeImg" [srcset]="objSrc.srcSets[0]">
                    <img src="data:image/png;base64, R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                        [alt]="slide.alt" [title]="slide.title" loading="lazy" class="img-fluid img-cover-width">
                </picture>
            </a>
        </div>
    </ng-template>
</swiper>